import { useTheme } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { ReactComponent as CheckDefIcon } from "assets/images/icons/checkbox_default.svg";
import { ReactComponent as CheckFillIcon } from "assets/images/icons/checkbox_fiilled.svg";

const CheckboxField = ({ label, checked, onChange, disabled = false, sx = {} }) => {
  const theme = useTheme();

  return (
    <FormControlLabel
      label={label}
      disabled={disabled}
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => onChange?.(e.target.checked)}
          disabled={disabled}
          icon={<CheckDefIcon style={{ width: 20, height: 20 }} />}
          checkedIcon={<CheckFillIcon style={{ width: 20, height: 20 }} />}
          sx={{
            padding: 0.5,
            display: "flex",
            alignItems: "center",

            "&:hover": {
              backgroundColor: "transparent",
            },
            ...sx
          }}
        />
      }
      sx={{
        margin: 0,
        gap: 1,
        display: "flex",
        alignItems: "center",

        ".MuiFormControlLabel-label": {
          fontSize: theme.typography.customFontSize[2],
          fontWeight: theme.typography.customFontWeight[1],
          userSelect: "none",
          lineHeight: 2.29,
        },
      }}
    />
  );
};


export default CheckboxField
